import { keycloak } from "@/data/keycloak";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { createContext, useContext, useState, useCallback } from "react";

interface KeycloakEventContextValue {
    event?: string;
    error?: string;
  }

const KeycloakEventContext = createContext<KeycloakEventContextValue>({});

export const useKeycloakEvent = () => useContext(KeycloakEventContext);


export const KeycloakProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [eventState, setEventState] = useState<KeycloakEventContextValue>({});

    const handleLogout = useCallback(() => {
      console.log("[Keycloak] Sessão encerrada no servidor, fazendo logout local...");
      localStorage.clear();
      window.location.href = import.meta.env.VITE_HUB_URL || "/";
    }, []);

    const handleEvent = useCallback((event: string, error?: any) => {
      console.log(`[Keycloak] Evento: ${event}`, error);

      // Eventos que indicam que a sessão foi encerrada
      if (event === "onAuthLogout") {
        console.log("[Keycloak] Logout detectado no servidor");
        handleLogout();
      }

      if (event === "onTokenExpired") {
        console.log("[Keycloak] Token expirado");
      }

      if (event === "onAuthRefreshError") {
        console.error("[Keycloak] Erro ao renovar token, sessão pode ter expirado");
        handleLogout();
      }

      if (error) {
        console.error("Keycloak event error:", event, error);
      }

      setEventState({ event, error: error?.message || null });
    }, [handleLogout]);

    return (
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={{
          onLoad: "check-sso",
          checkLoginIframe: true,
          checkLoginIframeInterval: 5,
          pkceMethod: "S256",
        }}
        onEvent={handleEvent}
      >
        <KeycloakEventContext.Provider value={eventState}>
          {children}
        </KeycloakEventContext.Provider>
      </ReactKeycloakProvider>
    );
  };
  